<template>
  <div v-loading="loading" class="crm-detail">
    <div class="toolbar toolbar-between">
      <div><el-button size="small" @click="$router.push('/crm/' + kind)">返回列表</el-button><span class="detail-title">{{ title }}</span></div>
      <div><crm-order-generate v-if="record && kind === 'contract'" :contract="record" /><crm-duplicates v-if="record && ['lead','customer'].includes(kind)" :kind="kind" :record="record" @merged="openMerged" /><el-button v-if="record && !record.inPool" size="small" @click="editRecord">编辑资料</el-button><el-button size="small" @click="load">刷新</el-button></div>
    </div>
    <el-alert v-if="error" :title="error" type="error" :closable="false" show-icon />
    <template v-else-if="record">
      <el-descriptions :title="kindLabel + '资料'" :column="3" border>
        <el-descriptions-item v-for="field in infoFields" :key="field[0]" :label="field[1]">{{ display(record[field[0]]) }}</el-descriptions-item>
      </el-descriptions>
      <el-tabs v-model="tab" class="detail-tabs">
        <el-tab-pane v-if="['customer','deal'].includes(kind)" :label="kind==='customer'?'客户360':'经营评估'" name="insights">
          <crm-insights v-if="tab==='insights'" :key="kind+record.id" :kind="kind" :record-id="record.id" />
        </el-tab-pane>
        <el-tab-pane v-if="kind === 'customer'" label="开票抬头" name="billing">
          <el-alert title="当前支持手工维护抬头与税号，请核实后填写。外部工商查询尚未接入。发票保存后保留当时的抬头快照。" type="info" :closable="false" />
          <el-form label-width="100px" class="followup-form" :disabled="!!record.inPool"><el-form-item label="开票抬头" required><el-input v-model="billing.invoiceTitle" maxlength="128" /></el-form-item><el-form-item label="税号"><el-input v-model="billing.taxNo" maxlength="32" /></el-form-item><el-form-item><el-button type="primary" :loading="savingBilling" @click="saveBilling">保存开票资料</el-button></el-form-item></el-form>
        </el-tab-pane>
        <el-tab-pane label="跟进时间线" name="activity">
          <el-form v-if="!record.inPool" :model="followup" label-width="80px" class="followup-form">
            <el-form-item label="跟进方式">
              <el-radio-group v-model="followup.channel"><el-radio-button label="CALL">通话</el-radio-button><el-radio-button label="WECHAT">企微</el-radio-button><el-radio-button label="NOTE">备注</el-radio-button></el-radio-group>
            </el-form-item>
            <el-form-item label="跟进内容"><el-input v-model="followup.content" type="textarea" :rows="3" maxlength="1000" show-word-limit placeholder="记录客户需求、沟通结果和下一步安排" /></el-form-item>
            <el-form-item><el-button type="primary" :loading="saving" @click="saveFollowup">保存跟进</el-button></el-form-item>
          </el-form>
          <el-empty v-if="!data.activities.length" description="暂无跟进记录" />
          <el-timeline v-else>
            <el-timeline-item v-for="item in data.activities" :key="item.id" :timestamp="item.createdAt" placement="top">
              <div class="timeline-meta">{{ channelLabel(item.channel) }} · {{ item.userId ? '记录人 #' + item.userId : '系统' }}</div>
              <div class="followup-content">{{ item.content }}</div>
            </el-timeline-item>
          </el-timeline>
        </el-tab-pane>
        <el-tab-pane label="扩展资料" name="custom">
          <el-empty v-if="!custom.fields.length" description="暂无启用的扩展字段，可由管理员在扩展字段中配置" />
          <el-form v-else label-width="130px" class="followup-form" :disabled="!!record.inPool">
            <el-form-item v-for="field in custom.fields" :key="field.fieldKey" :label="field.fieldLabel" :required="!!Number(field.requiredFlag)">
              <el-date-picker v-if="field.fieldType === 'DATE'" v-model="custom.values[field.fieldKey]" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width:100%" />
              <el-input v-else v-model="custom.values[field.fieldKey]" :maxlength="field.fieldType === 'NUMBER' ? 100 : 2000" :placeholder="field.fieldType === 'NUMBER' ? '填写数字' : '填写内容'" />
            </el-form-item>
            <el-form-item><el-button type="primary" :loading="savingValues" @click="saveValues">保存扩展资料</el-button></el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane :label="'联系人（' + data.contacts.length + '）'" name="contact">
          <div v-if="kind === 'customer' && !record.inPool" class="related-toolbar"><el-button type="primary" size="small" @click="createContact">新增联系人</el-button></div>
          <el-table :data="data.contacts" border empty-text="暂无关联联系人"><el-table-column prop="name" label="姓名" /><el-table-column prop="phone" label="电话" /><el-table-column prop="title" label="职务" /><el-table-column label="操作" width="90"><template slot-scope="{ row }"><el-button type="text" @click="$router.push({path:'/crm/contact',query:{recordId:row.id}})">查看</el-button></template></el-table-column></el-table>
        </el-tab-pane>
        <el-tab-pane :label="'商机（' + data.deals.length + '）'" name="deal">
          <el-table :data="data.deals" border empty-text="暂无关联商机"><el-table-column prop="title" label="商机" /><el-table-column prop="stage" label="阶段" /><el-table-column prop="amount" label="金额" /><el-table-column label="操作" width="90"><template slot-scope="{ row }"><el-button type="text" @click="$router.push('/crm/detail/deal/' + row.id)">详情</el-button></template></el-table-column></el-table>
        </el-tab-pane>
        <el-tab-pane :label="'报价（' + data.quotes.length + '）'" name="quote">
          <el-table :data="data.quotes" border empty-text="暂无关联报价"><el-table-column prop="quoteNo" label="报价单号" /><el-table-column prop="amount" label="金额" /><el-table-column prop="status" label="状态" /><el-table-column label="操作" width="100"><template slot-scope="{ row }"><el-button type="text" @click="$router.push({path:'/crm/quote',query:{quoteId:row.id}})">查看报价</el-button></template></el-table-column></el-table>
        </el-tab-pane>
        <el-tab-pane v-if="kind !== 'contract'" :label="'合同（' + data.contracts.length + '）'" name="contract">
          <el-table :data="data.contracts" border empty-text="暂无关联合同"><el-table-column prop="contractNo" label="合同编号" min-width="170" /><el-table-column prop="title" label="合同名称" min-width="180" /><el-table-column prop="amount" label="金额" /><el-table-column prop="status" label="状态" /><el-table-column label="操作" width="90"><template slot-scope="{ row }"><el-button type="text" @click="$router.push('/crm/detail/contract/' + row.id)">详情</el-button></template></el-table-column></el-table>
        </el-tab-pane>
        <el-tab-pane :label="'回款（' + data.payments.length + '）'" name="payment">
          <el-table :data="data.payments" border empty-text="暂无关联回款"><el-table-column label="合同" min-width="170"><template slot-scope="{ row }">{{ contractLabel(row.contractId) }}</template></el-table-column><el-table-column prop="periodName" label="期次" /><el-table-column prop="amount" label="金额" /><el-table-column prop="dueAt" label="到期时间" min-width="160" /><el-table-column label="状态"><template slot-scope="{ row }">{{ paymentStatus(row) }}</template></el-table-column><el-table-column label="操作" width="90"><template slot-scope="{ row }"><el-button type="text" @click="$router.push({path:'/crm/payment',query:{recordId:row.id}})">查看</el-button></template></el-table-column></el-table>
        </el-tab-pane>
        <el-tab-pane :label="'提醒（' + data.tasks.length + '）'" name="task">
          <div v-if="!record.inPool" class="related-toolbar"><el-button type="primary" size="small" @click="createTask">新增提醒</el-button></div>
          <el-table :data="data.tasks" border empty-text="暂无关联提醒"><el-table-column prop="title" label="事项" /><el-table-column prop="dueAt" label="到期时间" /><el-table-column prop="status" label="状态" /><el-table-column label="操作" width="90"><template slot-scope="{ row }"><el-button type="text" @click="$router.push({path:'/crm/task',query:{recordId:row.id}})">查看</el-button></template></el-table-column></el-table>
        </el-tab-pane>
      </el-tabs>
    </template>
  </div>
</template>

<script>
import { crm } from '../../api/crm'
import CrmDuplicates from '../../components/CrmDuplicates.vue'
import CrmOrderGenerate from '../../components/CrmOrderGenerate.vue'
import CrmInsights from '../../components/CrmInsights.vue'
import { paymentStatusLabel } from '../../utils/crmPaymentStatus'

const FIELDS = {
  lead: [['name', '姓名'], ['phone', '电话'], ['companyName', '公司'], ['source', '来源'], ['status', '状态'], ['ownerId', '负责人编号'], ['remark', '备注']],
  customer: [['name', '客户名称'], ['phone', '电话'], ['industry', '行业'], ['tier', '等级'], ['healthScore', '健康分'], ['ownerId', '负责人编号'], ['address', '地址'], ['remark', '备注']],
  deal: [['title', '商机名称'], ['stage', '阶段'], ['amount', '金额'], ['winRate', '赢率百分比'], ['ownerId', '负责人编号'], ['expectedCloseAt', '预计成交时间'], ['remark', '备注']],
  contract: [['title', '合同名称'], ['contractNo', '合同编号'], ['amount', '合同金额'], ['status', '状态'], ['startAt', '开始日期'], ['endAt', '结束日期'], ['remark', '备注']]
}
const blank = () => ({ activities: [], contacts: [], deals: [], quotes: [], contracts: [], payments: [], tasks: [] })

export default {
  name: 'CrmDetail',
  components: { CrmDuplicates, CrmOrderGenerate, CrmInsights },
  data() {
    return { record: null, data: blank(), custom: {fields: [], values: {}}, billing: {invoiceTitle:'',taxNo:''}, savingBilling:false, savingValues: false, loading: false, saving: false, error: '', tab: 'activity', followup: { channel: 'NOTE', content: '' }, requestId: 0, saveEpoch: 0 }
  },
  computed: {
    kind() { return this.$route.params.kind },
    kindLabel() { return { lead: '线索', customer: '客户', deal: '商机', contract: '合同' }[this.kind] || '记录' },
    title() { return this.record ? (this.record.name || this.record.title || this.kindLabel) : this.kindLabel + '详情' },
    infoFields() { return FIELDS[this.kind] || [] }
  },
  watch: { '$route.fullPath'() { this.saveEpoch++; this.savingBilling = false; this.savingValues = false; this.saving = false; this.followup.content = ''; this.tab = this.requestedTab(); this.load() } },
  created() { this.tab = this.requestedTab(); this.load() },
  methods: {
    requestedTab() { return ['contact', 'task'].includes(this.$route.query.tab) ? this.$route.query.tab : 'activity' },
    display(value) { return value === null || value === undefined || value === '' ? '—' : value },
    contractLabel(id) { const contract = this.data.contracts.find(row => row.id === id); return contract ? (contract.contractNo || '#' + id) + ' · ' + contract.title : '#' + id },
    paymentStatus(row) { return paymentStatusLabel(row, this.data.asOfDate) },
    channelLabel(value) { return { CALL: '通话', WECHAT: '企微', WECOM: '企微', NOTE: '备注', SYSTEM: '系统操作' }[value] || value },
    openMerged(id) { this.$router.replace('/crm/detail/' + this.kind + '/' + id) },
    editRecord() { if (this.record && !this.record.inPool) this.$router.push({ path: '/crm/' + this.kind, query: { recordId: this.record.id } }) },
    createContact() {
      if (this.kind !== 'customer' || !this.record || this.record.inPool) return
      this.$router.push({path:'/crm/contact',query:{create:'1',customerId:this.record.id,returnTo:this.$route.path}})
    },
    createTask() {
      if (!this.record || this.record.inPool) return
      this.$router.push({path:'/crm/task',query:{create:'1',bizType:this.kind.toUpperCase(),bizId:this.record.id,returnTo:this.$route.path}})
    },
    async saveBilling() {
      if (!this.record || this.savingBilling) return
      const requestId = this.requestId
      const saveEpoch = this.saveEpoch
      const customerId = this.record.id
      const values = { invoiceTitle: this.billing.invoiceTitle, taxNo: this.billing.taxNo }
      this.savingBilling = true
      try {
        const res = await crm.saveBillingTitle(customerId, values)
        if (requestId !== this.requestId || saveEpoch !== this.saveEpoch) return
        this.billing = res.data
        this.$message.success('开票资料已保存')
      } finally { if (saveEpoch === this.saveEpoch) this.savingBilling = false }
    },
    async saveValues() {
      if (!this.record || this.savingValues) return
      const requestId = this.requestId
      const saveEpoch = this.saveEpoch
      const type = this.kind.toUpperCase()
      const recordId = this.record.id
      const values = { ...this.custom.values }
      this.savingValues = true
      try {
        const res = await crm.saveCustomValues(type, recordId, values)
        if (requestId !== this.requestId || saveEpoch !== this.saveEpoch) return
        this.custom = res.data
        this.$message.success('扩展资料已保存')
      } finally { if (saveEpoch === this.saveEpoch) this.savingValues = false }
    },
    async load() {
      const requestId = ++this.requestId
      this.loading = true
      this.error = ''
      this.record = null
      this.data = blank()
      this.custom = { fields: [], values: {} }
      try {
        if (!FIELDS[this.kind]) throw new Error('不支持的详情类型')
        const [res, custom, billing] = await Promise.all([crm.detail(this.kind.toUpperCase(), this.$route.params.id), crm.customValues(this.kind.toUpperCase(), this.$route.params.id), this.kind==='customer' ? crm.billingTitle(this.$route.params.id) : Promise.resolve(null)])
        if (requestId !== this.requestId) return
        this.data = Object.assign(blank(), res.data)
        this.record = this.data.record
        this.custom = custom.data
        this.billing = billing ? {...billing.data,taxNo:billing.data.taxNo || ''} : {invoiceTitle:'',taxNo:''}
        this.custom.fields.forEach(field => { if (this.custom.values[field.fieldKey] === undefined) this.$set(this.custom.values, field.fieldKey, '') })
      } catch (e) {
        if (requestId === this.requestId) this.error = e.message || '记录无法访问，请返回列表刷新'
      } finally {
        if (requestId === this.requestId) this.loading = false
      }
    },
    async saveFollowup() {
      if (!this.record || this.saving) return
      const content = this.followup.content.trim()
      if (!content) return this.$message.warning('请填写跟进内容')
      const requestId = this.requestId
      const saveEpoch = this.saveEpoch
      const type = this.kind.toUpperCase()
      const recordId = this.record.id
      const channel = this.followup.channel
      this.saving = true
      try {
        await crm.saveActivity({ bizType: type, bizId: recordId, channel, content })
        if (requestId !== this.requestId || saveEpoch !== this.saveEpoch) return
        this.followup.content = ''
        this.$message.success('跟进已保存')
        await this.load()
      } finally { if (saveEpoch === this.saveEpoch) this.saving = false }
    }
  }
}
</script>

<style scoped>
.detail-title { margin-left: 16px; font-size: 20px; font-weight: 600; }
.detail-tabs { margin-top: 24px; }
.followup-form { max-width: 760px; padding: 16px 0; }
.timeline-meta { color: #64748b; margin-bottom: 8px; }
.followup-content { white-space: pre-wrap; overflow-wrap: anywhere; line-height: 1.7; }
.related-toolbar { display: flex; justify-content: flex-end; margin-bottom: 10px; }
</style>
